import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BriefcasePage } from './briefcase';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    BriefcasePage
  ],
  imports: [
    IonicPageModule.forChild(BriefcasePage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
  entryComponents: [
    BriefcasePage
  ]
})
export class BriefcasePageModule {}



// WEBPACK FOOTER //
// ./src/pages/briefcase/briefcase.module.ts